module.exports = __webpack_public_path__ + "static/media/chongoni_text_04.4a5b09f7.jpg";